import { render, staticRenderFns } from "./DataFilters.vue?vue&type=template&id=ec253112&scoped=true&"
import script from "./DataFilters.vue?vue&type=script&lang=js&"
export * from "./DataFilters.vue?vue&type=script&lang=js&"
import style0 from "./DataFilters.vue?vue&type=style&index=0&id=ec253112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec253112",
  null
  
)

export default component.exports